import { HttpClient } from '@angular/common/http';
import { Injectable, inject, signal } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { AppInfo } from './api.models';

/** Configuration publique de l'instance (`GET /api/info`), chargée au démarrage. */
@Injectable({ providedIn: 'root' })
export class ConfigService {
  private readonly http = inject(HttpClient);
  private readonly _info = signal<AppInfo | null>(null);

  readonly info = this._info.asReadonly();

  async load(): Promise<AppInfo> {
    const info = await firstValueFrom(this.http.get<AppInfo>('/api/info'));
    this._info.set(info);
    return info;
  }
}
